export default __webpack_public_path__ + "static/media/image00008.bbf8529e.jpeg";